import { MDText } from 'i18n-react';

import dayjs from 'Utilities/dayjs';

import { VALID_STATUSES } from './AcceptOffer.constants';
import LocalTexts from './AcceptOffer.texts.json';

const LocalT = new MDText(LocalTexts);

export const secondsToHms = (seconds) => {
  const days = Math.floor(seconds / (24 * 60 * 60));
  const remainderSeconds = seconds % (24 * 60 * 60);
  const hms = new Date(remainderSeconds * 1000).toISOString().substring(11, 19);
  return hms.replace(/^(\d+)/, (hours) => `${Number(hours) + days * 24}`.padStart(2, '0'));
};

export const calendarFormat = {
  lastDay: `[${LocalT.translate('calendar.yesterday')}] h:mm a`,
  lastWeek: `dddd [${LocalT.translate('calendar.at')}] h:mm a`,
  sameDay: `[${LocalT.translate('calendar.today')}] h:mm a`,
};

export const formatDateTime = (time) => dayjs(time).calendar(null, calendarFormat);

export const checkIf = (value, conditions) => {
  const check = {
    is: (data = []) => (data.some((it) => it === value)),
    not: (data = []) => (data.every((it) => it !== value)),
  };
  return Object.entries(conditions).every(([key, cond]) => check[key](cond));
};

export const getTimeLeft = (expiryTime) => {
  const now = new Date().getTime();
  const expire = new Date(expiryTime).getTime();

  return expire > now ? (expire - now) / 1000 : 0;
};

export const isNotValidOffer = (offer, vehicleVrm) => {
  const {
    closingBid,
    offerExpiry,
    state: { slug: state } = {},
    vehicleDetails: { vrm } = {},
  } = offer || {};

  return !offer || vehicleVrm !== vrm || !VALID_STATUSES.includes(state) || !closingBid || !offerExpiry;
};
